import {
  type HttpEvent,
  HttpHandler,
  type HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { from, Observable, switchMap } from 'rxjs';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  private cookieService = inject(CookieService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const csrfToken = this.cookieService.get('csrf_token');

    // Default
    if (!csrfToken) {
      if (window.location.host === 'localhost:4200') {
        // Make a request of the localhost:3000 server to make sure the CSRF cookie is set
        return from(fetch('http://localhost:3000/set-csrf')).pipe(
          switchMap(() => {
            const csrfToken2 = this.cookieService.get('csrf_token');
            const cloned2 = req.clone({
              headers: req.headers.set('csrf-token', csrfToken2),
            });
            return next.handle(cloned2);
          })
        );
      } else {
        return next.handle(req);
      }
    }

    const cloned = req.clone({
      headers: req.headers.set('csrf-token', csrfToken),
    });
    return next.handle(cloned);
  }
}
